<script lang="ts">
import { onActivated, onMounted, ref } from 'vue';

export interface PhxsgDomContentProps {
  nodes: ChildNode[];
}
</script>

<script setup lang="ts">
const props = defineProps<PhxsgDomContentProps>();

const contentElement = ref<HTMLElement | null>(null);

function moveNodes() {
  if (!contentElement.value) {
    return;
  }

  contentElement.value.replaceChildren(...props.nodes);
}

onMounted(() => {
  moveNodes();
});

onActivated(() => {
  moveNodes();
});
</script>

<template>
  <div ref="contentElement" style="display: contents"></div>
</template>
